/**
 * 名刺（通常・欧米・3号・スクエア・スリム・変形サイズ）の注文（価格表の表示とカート追加）
 * MEMO: 旧 js/order-meishi-normal.js の ESM 版
 *       用紙・オプション・加工の選択 UI は、src/order-common が #j-nxg_* の hidden input に値を入れる
 */
import '@/order-common'
import { setPriceLoader } from '@/order-common/price-loader'
import { onReady } from '@/utils/dom'
import { createPriceTableLoader, initPriceLinkAddCart } from '@/utils/order-price-table'
import type { PriceTableLayout } from '@/utils/order-price-table'
import { switchBothSidesColumns } from '@/utils/price-table'

//印刷タイプ（片面白黒・両面白黒・片面カラー・カラー×白黒・両面カラー）
const PRINT_TYPES = ['OPT_PRINT_TYPE_1_0', 'OPT_PRINT_TYPE_1_1', 'OPT_PRINT_TYPE_4_0', 'OPT_PRINT_TYPE_4_1', 'OPT_PRINT_TYPE_4_4']
//両面印刷できない用紙と、その場合に表示する印刷タイプ（片面のみ）
const BOTH_SIDES_IMPOSSIBLE_PAPERS = ['OPT_PAPER_0058']
const ONE_SIDE_PRINT_TYPES = ['OPT_PRINT_TYPE_1_0', 'OPT_PRINT_TYPE_4_0']
const MOBILE_TABLE_01 = '#order-price_table_mobile-01 tbody'
const MOBILE_TABLE_02 = '#order-price_table_mobile-02 tbody'

//小ロット（<body id> に 20 を含むページ）と通常ロットの違い
const isSmallLot = /20/.test(document.body.id)

/**
 * 用紙に応じた価格表ごとの印刷タイプ
 *   両面印刷できない用紙の場合は、片面の印刷タイプのみ（モバイル用は 1 つ目の表にまとめる）
 */
const getLayout = (): PriceTableLayout => {
    const paper = document.querySelector<HTMLInputElement>('#j-nxg_paper_opt')?.value ?? ''
    const bothSidesPossible = !BOTH_SIDES_IMPOSSIBLE_PAPERS.includes(paper)
    switchBothSidesColumns(bothSidesPossible)
    if(!bothSidesPossible) return { pc: ONE_SIDE_PRINT_TYPES, mobile: [[MOBILE_TABLE_01, ONE_SIDE_PRINT_TYPES]] }
    return {
        pc: PRINT_TYPES,
        mobile: [
            [MOBILE_TABLE_01, ['OPT_PRINT_TYPE_1_0', 'OPT_PRINT_TYPE_1_1', 'OPT_PRINT_TYPE_4_0']],
            [MOBILE_TABLE_02, ['OPT_PRINT_TYPE_4_1', 'OPT_PRINT_TYPE_4_4']],
        ],
    }
}

const loadPriceTable = createPriceTableLoader({
    printTypes: PRINT_TYPES,
    maxLotAmount: isSmallLot ? 4 : 50,
    unitNum: isSmallLot ? 20 : 100,
    lotName: isSmallLot ? 'セット' : '箱',
    getLayout,
})

onReady(() => {
    setPriceLoader(loadPriceTable)
    loadPriceTable()
    initPriceLinkAddCart()
})
